import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { toast } from 'react-toastify'
import { toastConfig } from '../../helpers/toastConfig'
import RootStore from '../../store/RootStore'
import IssueItem from '../Issue/IssueItem'
import UserSelect from '../AppHeader/UserSelect'
import TextFieldKeyboard from '../../components/forms/TextFieldKeyboard'
import '../../pages/Issue/styles/Issue.scss'

type Props = {}

const margin = 'dense'
const variant = 'standard'

const CompliteIssueWork = observer((props: Props) => {
  const open = RootStore.modalsUi.compliteIssueWork
  const issue = RootStore.modalsUi.issue

  const [comment, setComment] = React.useState('')

  const hundleClose = () => {
    RootStore.modalsUi.hundleCompliteIssueWork(false)
  }

  if (!issue) return <></>

  const hundleChange = async () => {
    const toastId = toast.loading('Обработка...', toastConfig)

    try {
      await RootStore.userAction.completeIssue(issue.id, comment)
      toast.update(toastId, {
        render: 'Работа завершена',
        type: 'success',
        isLoading: false,
        ...toastConfig,
      })
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
      if (data.property) {
      }
    }
  }

  return (
    <Dialog open={open} onClose={hundleClose} fullWidth maxWidth="sm">
      <DialogTitle>Завершить работу?</DialogTitle>
      <div className="issue-modals">
        <DialogContent>
          <UserSelect filters={{ role: issue.role ? issue.role.value : '' }} />
          <TextFieldKeyboard
            label="Комментарий"
            onChange={(event) => setComment(event.target.value)}
            multiline
            variant={variant}
            margin={margin}
            rows={3}
            fullWidth
          />
        </DialogContent>
          {issue ? <IssueItem issue={issue} noAction /> : null}
      </div>

      <DialogActions>
        <Button onClick={hundleChange}>Завершить</Button>
        <Button onClick={hundleClose}>Отмена</Button>
      </DialogActions>
    </Dialog>
  )
})

export default CompliteIssueWork
